import { FC, memo } from 'react'
import { Button, IconButton, Modal, ModalFooter, ModalHeader } from '@cargomart/ui'
import { FloatingOverlay } from '@floating-ui/react'
import cn from 'classnames'
import IconClose from 'remixicon/icons/System/close-fill.svg?react'

import { ModalFormDesktopProps } from './types'

const ModalFormDesktop: FC<ModalFormDesktopProps> = (props) => {
  const {
    desktopClassName,
    id,
    handleCloseWithConfirm,
    title,
    buttonCancelLabel = 'Отменить',
    buttonCancelVariant = 'outline',
    buttonId,
    buttonLabel = 'Сохранить',
    buttonOptionalSubmit,
    buttonOptionalIcon: ButtonOptionalIcon,
    buttonOptionalLabel,
    buttonOptionalLoading,
    buttonVariant = 'solid',
    headerAdditional,
    isDisableSubmit,
    isLoading,
    isStickyFooter,
    isStickyHeader,
    footerClassName,
    footerBefore,
    footerAfter,
    onOptional,
    size = 'nm',
    isCloseButton = true,
    children,
    isDialogType,
    ...otherProps
  } = props

  return (
    <FloatingOverlay lockScroll className="z-modal bg-[#000]/[0.3] [&>*]:h-auto">
      <Modal
        {...otherProps}
        isCloseOnEsc
        isCloseOnOutsideClick
        className={cn(desktopClassName, 'rounded-xl')}
        id={id}
        isDialogType={isDialogType}
        onClose={handleCloseWithConfirm}
        size={size}
      >
        <ModalHeader
          isBgSurface
          className="flex min-h-[72px] items-center justify-between gap-4 rounded-tl-xl rounded-tr-xl py-4 pl-6 pr-4"
          isSticky={isStickyHeader}
          tabIndex={0}
        >
          <div className="break-all text-headline-md">{title}</div>
          {isCloseButton && (
            <IconButton onClick={handleCloseWithConfirm} size="lg">
              <IconClose size="nm" />
            </IconButton>
          )}
          {headerAdditional}
        </ModalHeader>

        <div className="px-6">{children}</div>

        <ModalFooter
          isBgSurface
          className={cn(footerClassName, 'rounded-bl-xl rounded-br-xl p-6')}
          isSticky={isStickyFooter}
        >
          {footerBefore}
          <div className="flex w-full items-center justify-between">
            {buttonOptionalLabel && onOptional && (
              <Button
                className="mr-auto"
                data-test-id={`${id}Optional`}
                loading={buttonOptionalLoading}
                onClick={onOptional}
                prefix={ButtonOptionalIcon && <ButtonOptionalIcon />}
                size="lg"
                type={buttonOptionalSubmit ? 'submit' : undefined}
              >
                {buttonOptionalLabel}
              </Button>
            )}
            <div className="ml-auto flex gap-x-2">
              {buttonCancelLabel && (
                <Button
                  data-test-id={`${id}Cancel`}
                  onClick={handleCloseWithConfirm}
                  size="lg"
                  variant={buttonCancelVariant}
                >
                  {buttonCancelLabel}
                </Button>
              )}
              <Button
                data-test-id={`${id}Submit`}
                disabled={isDisableSubmit}
                id={buttonId}
                loading={isLoading}
                size="lg"
                type="submit"
                variant={buttonVariant}
              >
                {buttonLabel}
              </Button>
            </div>
          </div>
          {footerAfter}
        </ModalFooter>
      </Modal>
    </FloatingOverlay>
  )
}

export default memo(ModalFormDesktop)
